import isSampleVariantUtil from 'modules/variant/utils/is-sample'

/**
 * @param {ProductVariantCollection} productVariant
 * @param aovLock
 * @param subtotal
 * @param {ProductVariantCollection} selectedVariant
 * @param {boolean} needsToBeRatedSample
 * @returns {boolean}
 */
export const shouldShowAOVLockProductVariantSelectorUtil = ({
  productVariant,
  subtotal,
  selectedVariant,
  needsToBeRatedSample
}) => {
  if (needsToBeRatedSample) {
    return false
  }

  const aovLock = productVariant?.aov_lock
  if (!aovLock) {
    return false
  }

  if (!isSampleVariantUtil(productVariant)) {
    return false
  }

  if (
    selectedVariant &&
    !isSampleVariantUtil(selectedVariant)
  ) {
    return false
  }

  const aovLockFloat = parseFloat(aovLock)
  return subtotal < aovLockFloat
}
